import { render } from "./ClientProfile.vue?vue&type=template&id=0b18e536&scoped=true"
import script from "./ClientProfile.vue?vue&type=script&lang=js"
export * from "./ClientProfile.vue?vue&type=script&lang=js"

import "./ClientProfile.vue?vue&type=style&index=0&id=0b18e536&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b18e536"]])

export default __exports__